import { Details, Heading, Paragraph } from '@digdir/designsystemet-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Tiltak, TiltakKategori } from '../../../../../types/registration/tiltak';

import { StyledDetailsContent } from './styledComponents';

interface Props {
  tiltakMap: Map<TiltakKategori, Tiltak[]>;
  category: TiltakKategori;
}

export const TiltakSection: FC<Props> = ({ tiltakMap, category }) => {
  const tiltakList = tiltakMap.get(category) || [];
  const { t } = useTranslation();

  if (tiltakList.length === 0) {
    return null;
  }

  return (
    <Details>
      <Details.Summary>{t(`tiltak.category.${category}`)}</Details.Summary>
      <StyledDetailsContent>
        {tiltakList.map((tiltak, index) => (
          <div key={tiltak.tiltakId}>
            <Heading level={2} data-size="xs">
              Tiltak {index + 1}: {tiltak.navnBokmal}
            </Heading>
            <Paragraph>{tiltak.beskrivelseBokmal}</Paragraph>
          </div>
        ))}
      </StyledDetailsContent>
    </Details>
  );
};
